/** Admin dashboard — Tailwind class bundles */

export const adShell = "flex min-h-screen w-full bg-[#F9FAFB] font-sans text-[#111827]";

export const adSidebar =
  "flex w-64 shrink-0 flex-col gap-3 border-r border-slate-200/70 bg-white/70 p-5 text-slate-800 shadow-[0_1px_0_rgba(15,23,42,0.04)] backdrop-blur-xl";

export const adMain = "flex min-w-0 flex-1 flex-col space-y-6 overflow-x-auto p-5 md:p-8";

export const adNavBtn =
  "flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm font-semibold text-slate-700 transition hover:bg-slate-50";

export const adNavBtnActive =
  "bg-gradient-to-r from-pink-50 via-rose-50 to-amber-50 text-slate-900 ring-1 ring-pink-100";

export const adNavBtnIdle = "";

export const adCard =
  "rounded-2xl border border-slate-200/70 bg-white/80 p-6 shadow-md backdrop-blur-xl transition-all duration-300 hover:shadow-[0_0_30px_rgba(250,204,21,0.22)]";

export const adPrimaryBtn =
  "inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-pink-400 to-yellow-300 px-6 py-2.5 font-semibold text-white shadow-md transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(250,204,21,0.35)] active:scale-95 disabled:pointer-events-none disabled:opacity-50";

export const adEditBtn =
  "inline-flex items-center gap-2 rounded-full bg-rose-500 px-4 py-2 text-sm font-semibold text-white shadow transition hover:scale-105 hover:bg-rose-600 hover:shadow-lg";

export const adDeleteBtn =
  "inline-flex items-center gap-2 rounded-full bg-red-400 px-4 py-2 text-sm font-semibold text-white shadow transition hover:scale-105 hover:bg-red-500 hover:shadow-lg";

export const adSecondaryBtn =
  "inline-flex items-center justify-center rounded-full border border-slate-200 bg-white/80 px-5 py-2.5 text-sm font-semibold text-slate-800 shadow-sm transition hover:bg-slate-50";

export const adInput =
  "w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none ring-0 transition focus:border-pink-300 focus:ring-2 focus:ring-pink-500/20";

export const adTableWrap = "w-full overflow-hidden rounded-2xl border border-slate-200/70 bg-white shadow-sm";

export const adThead = "bg-slate-50 text-left text-sm font-semibold text-slate-700";

export const adTh = "px-4 py-3";

export const adTd = "px-4 py-3";

export const adTrHover = "border-t border-slate-100 transition hover:bg-slate-50";

export const adBadgeNew =
  "inline-flex items-center rounded-full bg-emerald-50 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-emerald-700 ring-1 ring-emerald-200";

export const adEmpty =
  "rounded-2xl border border-dashed border-slate-200 bg-white/60 py-14 text-center text-sm text-slate-500";

export const adLogoutBtn =
  "mt-auto inline-flex items-center justify-center border-0 rounded-[8px] bg-gradient-to-r from-pink-400 to-yellow-300 px-[18px] py-[8px] text-sm font-semibold text-white shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-[0_0_15px_rgba(236,72,153,0.4)]";

export const adTopbar =
  "sticky top-0 z-30 flex items-center justify-between gap-3 rounded-2xl border border-slate-200/70 bg-white/70 px-4 py-3 shadow-sm backdrop-blur-xl";

export const adIconBtn =
  "inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white/80 text-slate-700 shadow-sm transition hover:bg-slate-50 hover:text-slate-900";

export const adPill =
  "inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/80 px-3 py-2 text-sm font-semibold text-slate-800 shadow-sm";
